import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Projectgoal() {
  return (
    <section className="p-100 bg_textcolor" style={{ background: "#3E6033" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>The Idea Behind TeeMates</h2>
            <p>
              Client wished to create an all-in-one social media platform fully
              dedicated to golfers. She wanted to break geographic barriers, and
              help golfers find mates who have similar passion.
            </p>
            <p>
              During the discovery stage, our creative and development teams
              realized that golfers needed not only an app, but a community
              platform where they could discuss inspirations, experiences and
              challenges of this very sport, hold local networking events and
              buy and sell equipment that could help others level up their game.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectgoal;
